import React, { useCallback } from "react";

import type { MultiSelectProps } from "./MultiSelect.types";

import "./MultiSelect.css";

const MultiSelect: React.FC<MultiSelectProps> = ({
  items,
  selectedIds,
  onChange,
}) => {
  const handleToggle = useCallback(
    (id: number) => {
      const next = selectedIds.includes(id)
        ? selectedIds.filter((x) => x !== id)
        : [...selectedIds, id];
      onChange(next);
    },
    [selectedIds, onChange],
  );

  return (
    <div>
      {items.map((item) => (
        <label
          key={item.id}
          className="multi-select-item"
        >
          <input
            type="checkbox"
            checked={selectedIds.includes(item.id)}
            onChange={() => handleToggle(item.id)}
          />
          <span>{item.label}</span>
        </label>
      ))}
    </div>
  );
};

export default MultiSelect;
